import React, { FC, useContext } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { AnimatedScreen, LoadingPage, PageHeader } from 'Shared/components';
import { PartnerContext } from 'Admin/utils';

import {
  CommissionForm,
  CommissionFormType,
  CommissionStructure,
} from '../../components';

const commissionSchema = Yup.object().shape({
  effectiveDate: Yup.string().required('Required'),
  endDate: Yup.string().test({
    name: 'end date before effective date',
    test: function () {
      if (!this.parent.endDate || !this.parent.effectiveDate) return true;

      const start = new Date(this.parent.effectiveDate);
      const end = new Date(this.parent.endDate);
      return end < start
        ? this.createError({
            message: 'End date must be on or after Effective date',
            path: 'endDate',
          })
        : true;
    },
  }),
  commissionStructure: Yup.string().required('Required'),
  commissionTemplate: Yup.string().when('commissionStructure', {
    is: CommissionStructure.Commission,
    then: Yup.string().required('Required'),
    otherwise: Yup.string().notRequired(),
  }),
});

export const Create: FC = () => {
  const { loading, currentPartner } = useContext(PartnerContext);

  if (loading) return <LoadingPage />;

  if (!currentPartner) {
    return null;
  }

  return (
    <AnimatedScreen testId="create-commission">
      <PageHeader heading="Commission" />
      <Formik<CommissionFormType>
        initialValues={{
          effectiveDate: '',
          endDate: '',
          commissionStructure: CommissionStructure.Commission,
          commissionTemplate: '',
        }}
        validationSchema={commissionSchema}
        onSubmit={async () => {
          console.log('Submit');
        }}
      >
        <CommissionForm type="create" />
      </Formik>
    </AnimatedScreen>
  );
};
